export default {
  loading: {
    pointerEvents: 'none',
    opacity: 0.5,
  },
};
